// extracted by mini-css-extract-plugin
export var BreadcrumbItem = "Breadcrumbs-module--BreadcrumbItem--0f100";
export var BreadcrumbLink = "Breadcrumbs-module--BreadcrumbLink--368c6";
export var BreadcrumbList = "Breadcrumbs-module--BreadcrumbList--87d09";
export var BreadcrumbWrapper = "Breadcrumbs-module--BreadcrumbWrapper--708c0";
export var between = "Breadcrumbs-module--between--08af8";